import { Tabs, message } from 'antd';
import { Dayjs } from 'dayjs';
import { FC, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { getDefaultDates } from 'src/utils/date-util';
import { formatDate } from 'src/utils/date-util';

import useOutboundTransactions from 'src/hooks/subscription/useOutboundTransactions';
import useDateForTableOptions from 'src/hooks/useDateForTableOptions';
import { useTitle } from 'src/hooks/useTitle';

import InventoryOutboundHistoryTable from 'src/atomic-components/organisms/Tables/InventoryOutboundHistoryTable';
import TableOptions from 'src/components/Common/TableOptions/TableOptions';
import Loading from 'src/components/Loading/Loading';

const defaultValue = getDefaultDates(0, 0);
const dayjsesToStringDateWhere = (left: Dayjs, right: Dayjs): [string, string] => {
  const leftDate = formatDate(left.toDate(), 'yyyy-MM-dd');
  const rightDate = formatDate(right.toDate(), 'yyyy-MM-dd');
  return [leftDate, rightDate];
};

const InventoryOutboundHistoryBoard: FC = () => {
  useTitle('출고 내역');
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const tab = searchParams.get('tab') || 'all';
  const { dates, setDates, leftDate, rightDate } = useDateForTableOptions(dayjsesToStringDateWhere, defaultValue);
  const { outboundTransactions, loading, error } = useOutboundTransactions(tab, leftDate, rightDate);

  const onTabChange = (key: string) => {
    navigate(`../outbound-history?tab=${key}`);
  };

  useEffect(() => {
    if (error) {
      message.error(error, 10);
    }
  }, [error]);

  return (
    <div className='height100 flexColumn'>
      <TableOptions setDates={setDates} defaultValue={dates} />
      <Tabs
        activeKey={tab}
        onChange={onTabChange}
        style={{ height: '100%', overflow: 'scroll' }}
        items={[
          {
            key: 'all',
            label: '전체 출고',
            children: <InventoryOutboundHistoryTable rowData={outboundTransactions} />,
          },
          {
            key: 'order',
            label: '주문',
            children: <InventoryOutboundHistoryTable rowData={outboundTransactions} hideReferenceCollection={true} />,
          },
          {
            key: 'issue',
            label: '재고 이슈',
            children: <InventoryOutboundHistoryTable rowData={outboundTransactions} hideReferenceCollection={true} />,
          },
          {
            key: 'store',
            label: '매장 이슈',
            children: <InventoryOutboundHistoryTable rowData={outboundTransactions} hideReferenceCollection={true} />,
          },
        ]}
      />
      {loading && <Loading title='출고 내역 로딩중...' />}
    </div>
  );
};

export default InventoryOutboundHistoryBoard;
